import { render, staticRenderFns } from "./MatchRefereeList.vue?vue&type=template&id=0e07f4a8&scoped=true&"
import script from "./MatchRefereeList.vue?vue&type=script&lang=js&"
export * from "./MatchRefereeList.vue?vue&type=script&lang=js&"
import style0 from "./MatchRefereeList.vue?vue&type=style&index=0&id=0e07f4a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07f4a8",
  null
  
)

export default component.exports